import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateRange } from 'src/shared/models/date-range.model';

export function dateOverlapValidator(dateRanges: DateRange[], startDateIndex: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const startDate = new Date(control.value);

    for (let i = 0; i < dateRanges.length; i++) {
      const range = dateRanges[i];
      if (range === null || startDateIndex === i) { continue; }

      const rangeStartDate = new Date(range.start_date);
      const rangeEndDate = new Date(range.end_date);

      if (startDate >= rangeStartDate && startDate <= rangeEndDate) {
        return { dateOverlap: true };
      }
    }

    return null;
  };
}
